// Docs: https://connectrpc.com/docs/introduction

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file query/v3/scope.proto (package query.v3, syntax proto3)
/* eslint-disable */

// Package query.v3 defines the protocol buffer messages and services
// for querying data dynamically typically used by chats and actions.

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AuditMetadata, Share } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { Realm } from "../../realm/v3/realm_pb";
import { file_realm_v3_realm } from "../../realm/v3/realm_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file query/v3/scope.proto.
 */
export const file_query_v3_scope: GenFile =
  /*@__PURE__*/
  fileDesc(
    "ChRxdWVyeS92My9zY29wZS5wcm90bxIIcXVlcnkudjMingEKDlRleHRBdHRhY2htZW50Ei8KEnRleHRfYXR0YWNobWVudF9pZBgBIAEoCUITmrUYD3N0aWQuQXR0YWNobWVudBIZChFleHRyYWN0ZWRfY29udGVudBgCIAEoCRIRCglmaWxlX25hbWUYAyABKAkSEQoJZmlsZV9zaXplGAQgASgDEhQKDGNvbnRlbnRfdHlwZRgFIAEoCUoECAYQCyJPCg5GaWxlQXR0YWNobWVudBIqCg1hdHRhY2htZW50X2lkGAEgASgJQhOatRgPc3RpZC5BdHRhY2htZW50EhEKCWZpbGVfbmFtZRgCIAEoCSLhAwoFU2NvcGUSNgoUdGV4dF9hdHRhY2htZW50X2xpc3QYCiADKAsyGC5xdWVyeS52My5UZXh0QXR0YWNobWVudBIvChJhdHRhY2htZW50X2lkX2xpc3QYCyADKAlCE5q1GA9zdGlkLkF0dGFjaG1lbnQSJQoNYXNzZXRfaWRfbGlzdBhkIAMoCUIOmrUYCnN0aWQuQXNzZXQSKwoQYXJ0aWZhY3RfaWRfbGlzdBhlIAMoCUIRmrUYDXN0aWQuQXJ0aWZhY3QSJQoNbGFiZWxfaWRfbGlzdBhmIAMoCUIOmrUYCnN0aWQuTGFiZWwSKQoPY29uY2VwdF9pZF9saXN0GGcgAygJQhCatRgMc3RpZC5Db25jZXB0EikKD3Byb2plY3RfaWRfbGlzdBhoIAMoCUIQmrUYDHN0aWQuUHJvamVjdBIoCgx3b3Jrc3BhY2VfaWQYaSABKAlCEpq1GA5zdGlkLldvcmtzcGFjZRIuCg9vcmdhbml6YXRpb25faWQYaiABKAlCFZq1GBFzdGlkLk9yZ2FuaXphdGlvbkoECAEQCkoECAwQZEoFCGsQ6AdKCAigjQYQwJoMSggIwJoMEOCnEkoICOCnEhCAtRhKCAiAtRgQoMIeSgkIoMIeEIHlmncixAEKDUVucmljaGVkU2NvcGUSIgoCaWQYASABKAlCFpq1GBJzdGlkLkVucmljaGVkU2NvcGUSJgoLYm91bmRhcnlfaWQYAiABKAlCEZq1GA1zdGlkLkJvdW5kYXJ5Eh4KBXJlYWxtGAMgASgLMg8ucmVhbG0udjMuUmVhbG0SJwoFYXVkaXQYBCABKAsyGC5jb21tb24udjMuQXVkaXRNZXRhZGF0YRIeCgVzY29wZRgFIAEoCzIPLnF1ZXJ5LnYzLlNjb3BlIogBCglTY29wZVZpZXcSIwoHdmlld19pZBgBIAEoCUISmrUYDnN0aWQuU2NvcGVWaWV3EiYKBXNjb3BlGAIgASgLMhcucXVlcnkudjMuRW5yaWNoZWRTY29wZRIkCgVzaGFyZRgDIAEoCzIQLmNvbW1vbi52My5TaGFyZUgAiAEBQggKBl9zaGFyZUJZWldnaXRodWIuY29tL1N0b3J5dGVsbC1haS9zdG9yeXRlbGwtYWktcGxhdGZvcm0vcGtnL2dvL2RvbWFpbnMvY3AvZ2VuL3BiL3F1ZXJ5L3YzO3F1ZXJ5VjNiBnByb3RvMw",
    [file_common_v3_common, file_realm_v3_realm],
  );

/**
 * @generated from message query.v3.TextAttachment
 */
export type TextAttachment = Message<"query.v3.TextAttachment"> & {
  /**
   * The ID of the text attachment.
   * Format: ^textAttachment_[a-z0-9]{20}$
   *
   * The ID of the text attachment.
   *
   * @generated from field: string text_attachment_id = 1;
   */
  textAttachmentId: string;

  /**
   * The extracted content from the attachment.
   *
   * @generated from field: string extracted_content = 2;
   */
  extractedContent: string;

  /**
   * The name of the file.
   *
   * @generated from field: string file_name = 3;
   */
  fileName: string;

  /**
   * The size of the file in bytes.
   *
   * @generated from field: int64 file_size = 4;
   */
  fileSize: bigint;

  /**
   * The MIME type of the file.
   *
   * @generated from field: string content_type = 5;
   */
  contentType: string;
};

/**
 * Describes the message query.v3.TextAttachment.
 * Use `create(TextAttachmentSchema)` to create a new message.
 */
export const TextAttachmentSchema: GenMessage<TextAttachment> = /*@__PURE__*/ messageDesc(file_query_v3_scope, 0);

/**
 * @generated from message query.v3.FileAttachment
 */
export type FileAttachment = Message<"query.v3.FileAttachment"> & {
  /**
   * The ID of the file attachment.
   * Format: ^attachment_[a-z0-9]{20}$
   *
   * @generated from field: string attachment_id = 1;
   */
  attachmentId: string;

  /**
   * @generated from field: string file_name = 2;
   */
  fileName: string;
};

/**
 * Describes the message query.v3.FileAttachment.
 * Use `create(FileAttachmentSchema)` to create a new message.
 */
export const FileAttachmentSchema: GenMessage<FileAttachment> = /*@__PURE__*/ messageDesc(file_query_v3_scope, 1);

/**
 * Scope defines the scope of knowledge for an operation.
 * These params may be populated by a client.
 *
 * @generated from message query.v3.Scope
 */
export type Scope = Message<"query.v3.Scope"> & {
  /**
   * A text attachment is a file (or paste) that contains text that was able
   * to be extracted on the client. The text attachment may become an asset
   * if added to the collective knowledge base.
   *
   * @generated from field: repeated query.v3.TextAttachment text_attachment_list = 10;
   */
  textAttachmentList: TextAttachment[];

  /**
   * An attachment could be a file, image, or any other resource and may later
   * become an asset if added to the collective knowledge base.
   *
   * Format: ^attachment_[a-z0-9]{20}$
   *
   * @generated from field: repeated string attachment_id_list = 11;
   */
  attachmentIdList: string[];

  /**
   * Targets individual assets (e.g., PDFs, CSVs, etc.).
   * Equal weight to attachments sourced from a knowledge base.
   *
   * Format: ^asset_[a-z0-9]{20}$
   *
   * @generated from field: repeated string asset_id_list = 100;
   */
  assetIdList: string[];

  /**
   * Targets specific artifacts (e.g., model outputs, analysis results,
   * logs, and answers). Artifacts are produced by chats or actions.
   *
   * Humans can edit artifacts to massage the generated data and publish them.
   * When shared, humans are encouraged to chat with artifacts to get the most
   * out of them.
   *
   * Format: ^artifact_[a-z0-9]{20}$
   *
   * @generated from field: repeated string artifact_id_list = 101;
   */
  artifactIdList: string[];

  /**
   * Targets any data associated with specific labels (#simple #tags).
   * Wider scope than individual assets, but more specific than concepts or
   * projects as humans curate labels and manually associate to entities
   * such as assets, concepts, artifacts, etc.
   *
   * Format: ^label_[a-z0-9]{20}$
   *
   * @generated from field: repeated string label_id_list = 102;
   */
  labelIdList: string[];

  /**
   * Targets concepts built-up from knowledge (richer, ontology-linked
   * identifiers). Targeting a concept is more about the meaning of the
   * data rather than the data itself and may result in gathering related
   * concepts and the data that supports them.
   *
   * This is a wide net to cast but targeted to one or ideas.
   *
   * Format: ^concept_[a-z0-9]{20}$
   *
   * @generated from field: repeated string concept_id_list = 103;
   */
  conceptIdList: string[];

  /**
   * Targets any data organized within specific projects.
   * Wider scope than concepts or labels, encompassing potentially many assets,
   * concepts, and attachments. User's house knowledge within projects and
   * may scope a project to a specific task or goal.
   *
   * Format: ^project_[a-z0-9]{20}$
   *
   * @generated from field: repeated string project_id_list = 104;
   */
  projectIdList: string[];

  /**
   * Targets a specific workspace
   *
   * @generated from field: string workspace_id = 105;
   */
  workspaceId: string;

  /**
   * Targets a specific organization
   *
   * @generated from field: string organization_id = 106;
   */
  organizationId: string;
};

/**
 * Describes the message query.v3.Scope.
 * Use `create(ScopeSchema)` to create a new message.
 */
export const ScopeSchema: GenMessage<Scope> = /*@__PURE__*/ messageDesc(file_query_v3_scope, 2);

/**
 * EnrichedScope is a wrapper around the Scope message
 * with server-provided values.
 *
 * @generated from message query.v3.EnrichedScope
 */
export type EnrichedScope = Message<"query.v3.EnrichedScope"> & {
  /**
   * Format: ^enrichedScope_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Format: ^boundary_[a-z0-9]{20}$
   *
   * @generated from field: string boundary_id = 2;
   */
  boundaryId: string;

  /**
   * The realm associated with the scope which defines permission
   * boundaries and the location of the scope.
   *
   * @generated from field: realm.v3.Realm realm = 3;
   */
  realm?: Realm;

  /**
   * Complete audit trail for this entity, including creation,
   * modification, and deletion information.
   *
   * @generated from field: common.v3.AuditMetadata audit = 4;
   */
  audit?: AuditMetadata;

  /**
   * The knowledge scope for this operation.
   *
   * @generated from field: query.v3.Scope scope = 5;
   */
  scope?: Scope;
};

/**
 * Describes the message query.v3.EnrichedScope.
 * Use `create(EnrichedScopeSchema)` to create a new message.
 */
export const EnrichedScopeSchema: GenMessage<EnrichedScope> = /*@__PURE__*/ messageDesc(file_query_v3_scope, 3);

/**
 * @generated from message query.v3.ScopeView
 */
export type ScopeView = Message<"query.v3.ScopeView"> & {
  /**
   * Unique Identifier for the view.
   * This ID allows for referencing and managing specific instances of a
   * defined Scope. It follows a consistent format for easy identification.
   *
   * Format: ^scopeView_[a-z0-9]{20}$
   *
   * @generated from field: string view_id = 1;
   */
  viewId: string;

  /**
   * The scope associated with this view.
   *
   * @generated from field: query.v3.EnrichedScope scope = 2;
   */
  scope?: EnrichedScope;

  /**
   * The share settings for this view.
   *
   * @generated from field: optional common.v3.Share share = 3;
   */
  share?: Share;
};

/**
 * Describes the message query.v3.ScopeView.
 * Use `create(ScopeViewSchema)` to create a new message.
 */
export const ScopeViewSchema: GenMessage<ScopeView> = /*@__PURE__*/ messageDesc(file_query_v3_scope, 4);
